import React from "react";

import "../style/reset.css"
import "../style/typography.css"

import SEO from "../components/seo";
import styled, {ThemeProvider} from "styled-components";
import {useThemes} from "../style/themes.hook";
import {CookiesProvider} from "react-cookie";
import {
  CtaWireframeButton,
  FullWidthContainer,
  GlobalStyle,
  HashTag,
  Heading1,
  Heading2,
  Heading3,
  Heading4, InternalLink,
  ListItem,
  MaxWidthContainer,
  MiniParagraph, Paragraph,
  UnorderedList
} from "../style/itf-styled-components";
import Header from "../components/header/header";
import Footer from "../components/footer";
import LogoSVG from "../../static/svg/logo.svg"
import {ExternalLink} from "../components/external-link";
import CookiesConsent from "../components/cookies-consent";
import {useLogisticPartners, useMediaPartners} from "../data/hooks/partners";
import PartnerBox from "../components/partner-box";
import NewsletterForm from "../components/forms/newsletter-form";
import {WeimagineSection} from "../components/home-page/weimagine-section";
import {YouimagineSection} from "../components/home-page/youimagine-section";
import {VimagineSection} from "../components/home-page/vimagine-section";
import {Section} from "../components/home-page/section";
import Slider from "../components/home-page/slider";

const WelcomeSection = () => {
  const themes = useThemes();

  return (
    <ThemeProvider theme={themes.light}>
      <MaxWidthContainer
        as={Section}
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 100px;
    
          @media (max-width: ${props => props.theme.mobileWidth}) {
            display: flex;
            flex-direction: column;
          }
        `}
      >
        <div>
          <Heading4>Bine ați venit la Imagine Timisoara Festival, ediția a III-a!</Heading4>
          <Heading4>Cel mai amplu festival de fotografie și videografie din țară revine în 2021 cu un program special!</Heading4>
        </div>
        <div>
          <UnorderedList>
            <ListItem>3 conferințe</ListItem>
            <ListItem>21 de workshopuri</ListItem>
            <ListItem>5 concursuri de fotografie</ListItem>
            <ListItem>8 expoziții</ListItem>
            <ListItem>o emisiune maraton in format live</ListItem>
            <ListItem>o premieră de film documentar</ListItem>
            <ListItem>un târg de echipamente foto-video</ListItem>
            <ListItem>o sesiune de portofolio review</ListItem>
          </UnorderedList>
          <Paragraph><CtaWireframeButton>Cumpără bilet</CtaWireframeButton></Paragraph>
        </div>
      </MaxWidthContainer>
      <MaxWidthContainer css={`padding: 0 25px;`}>
        <Heading2>Descoperă cele trei secțiuni ale Imagine Timisoara Festival 2021:</Heading2>
      </MaxWidthContainer>
    </ThemeProvider>
  );
}
const NewsletterSection = () => {
  return (
      <MaxWidthContainer as={Section}>
        <HashTag>Newsletter-ul ITF</HashTag>
        <MiniParagraph
            css={`
              margin: 30px 0;
            `}
        >Abonează-te și fii primul care află ultimele noutăți!</MiniParagraph>
        <NewsletterForm />
      </MaxWidthContainer>
  );
}
const SponsorsSection = () => {
  const mediaPartners = useMediaPartners();
  const logisticPartners = useLogisticPartners();
  const themes = useThemes();

  const PartnersList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  `;

  const Partner = styled(ExternalLink)`
    padding: 10px;
  `;

  return (
      <ThemeProvider theme={themes.light}>
        <MaxWidthContainer as={Section}>
          <Heading2>Sponsorii și partenerii Imagine Timisoara Festival</Heading2>
          <div
            css={`
              display: grid;
              grid-template-columns: 1fr 1fr;
              column-gap: 25px;
              padding-bottom: 100px;
              padding-top: 25px;
    
              @media (max-width: ${props => props.theme.mobileWidth}) {
                display: flex;
                flex-direction: column;
              }
            `}
          >
            {!!mediaPartners.length && (
            <div>
              <Heading3>Partenerii media</Heading3>
              <PartnersList>
                {
                  mediaPartners.map((partner, index) => (
                      <Partner to={partner.website} key={index}>
                        <PartnerBox partner={partner} size="small"/>
                      </Partner>
                  ))
                }
              </PartnersList>
            </div>)}
          {!!logisticPartners.length && (<div>
              <Heading3>Partenerii logistici</Heading3>
              <PartnersList>
                {
                  logisticPartners.map((partner, index) => (
                      <Partner to={partner.website} key={index}>
                        <PartnerBox partner={partner} size="small"/>
                      </Partner>
                  ))
                }
              </PartnersList>
            </div>)}
            <Paragraph><CtaWireframeButton
              as={InternalLink}
              to="/parteneri"
            >Vezi toți partenerii</CtaWireframeButton></Paragraph>
          </div>
        </MaxWidthContainer>
      </ThemeProvider>
  );
}
const FestivalCover = () => {
  const themes = useThemes();

  return (
    <ThemeProvider theme={themes.contrastLight}>
        <Section
            css={`
              background-image: url("../images/pink-frontal-catalin-anghel-shooting.jpg");
              background-size: cover;
              box-shadow: 0 4px 8px rgba(31, 41, 46, 0.16), 0 16px 16px rgba(31, 41, 46, 0.08);
              align-items: center;
              margin-bottom: 50px;
              padding-top: 100px;
            `}
        >
            <MaxWidthContainer
              css={`
                padding: 0 25px;
              `}
            >
                <div>
                    <LogoSVG
                      css={`
                        width: 40vw;
                        max-width: 320px;
                    
                        path {
                          fill: ${props => props.theme.colors.neutrals._900};
                        }
                      `}
                    />
                    <Heading3>Ediția a III-a</Heading3>
                    <Heading3>Timișoara</Heading3>
                    <Heading2
                      css={`
                        display: inline-block;
                        margin-right: 20px;
                        vertical-align: middle;
                      `}
                    >6-9 septembrie 2021</Heading2>
                    <Heading1>Focus to inspire</Heading1>
                </div>
            </MaxWidthContainer>
        </Section>
    </ThemeProvider>
  );
}

const HomePage = () => {
  const themes = useThemes();

  return (
    <>
      <CookiesProvider>
        <SEO
            title={`Imagine Timisoara Festival 2021`}
            description={`Imagine Timisoara Festival, ediția III - 6-9 septembrie 2021 - Cel mai amplu eveniment dedicat fotografiei și videografiei din țară`}
        />
      </CookiesProvider>
      <ThemeProvider theme={themes.light}>
        <GlobalStyle/>
        <FullWidthContainer>
          <Header page="home"/>

          <FestivalCover />

          <WelcomeSection />
          <WeimagineSection />
          <YouimagineSection />
          <VimagineSection />
          <Slider />
          <NewsletterSection />
          <SponsorsSection />

        </FullWidthContainer>
        <Footer />

        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      </ThemeProvider>
    </>
  );
};

export default HomePage
